<button
  mat-button
  vueTableMenuOpen
  vueOverlayOpen
  class="menu-trigger"
  [attr.aria-label]="'label.poolsOverview.actionsMenu'| translate:pool.name | async"
  [matMenuTriggerFor]="allPoolsMenu"
>
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #allPoolsMenu="matMenu" class="all-pools-menu">
  <a mat-menu-item routerLink="../{{pool.id}}" routerLinkActive="active">
    {{ "label.poolOccurrence.viewPoolDetails" | translate | async }}
  </a>
  <a mat-menu-item *ngIf="isPoolArchived(pool) && !isPoolEnds(pool)" (click)="poolUnarchived()">
    {{ "label.poolOccurrence.unarchived" | translate | async }}
  </a>
  <button
    *ngIf="isPoolEditable(pool)"
    mat-menu-item
    (click)="openEditDrawer()"
  >
    {{ "label.poolsOverview.editPool" | translate | async }}
  </button>
  
   <button mat-menu-item  (click)="openDuplicateDrawer()">
    {{ "label.poolsOverview.duplicatePool" | translate | async }}
  </button>
</mat-menu>
<app-edit-pool-drawer
  *ngIf="isPoolEditable(pool)"
  [poolId]="pool.id"
  [showOpenButton]="false"
></app-edit-pool-drawer>
<app-add-pool-drawer  [poolId]="pool.id" [showOpenButton]="false" ></app-add-pool-drawer>
